import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/36_christmas_wall/36_christmas_wall"
 * Contains 1 texture(s)
 */
export class Mobile36ChristmasWallAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/36_christmas_wall/36_christmas_wall';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '36_christmas_wall.png'
    ] as const;
}
